
import pic0 from '../assets/ellie/ellie10.jpg'
import pic1 from '../assets/ellie/ellie1.png'
import pic2 from '../assets/ellie/ellie2.png'
import pic3 from '../assets/ellie/ellie3.png'
import pic4 from '../assets/ellie/ellie4.png'
import pic5 from '../assets/ellie/ellie5.png'
import pic6 from '../assets/ellie/ellie6.png'
import pic7 from '../assets/ellie/ellie7.png'
import pic8 from '../assets/ellie/ellie8.jpg'
import pic9 from '../assets/ellie/ellie9.jpg'
// import pic10 from '../assets/ellie/ellie10.jpg'


const Pictures = [
    {
        src: `${pic0}`,
        id: 0
    },
    {
        src: `${pic1}`,
        id: 1
    },
    {
        src: `${pic2}`,
        id: 2
    },
    {
        src: `${pic3}`,
        id: 3
    },
    {
        src: `${pic4}`,
        id: 4
    },
    {
        src: `${pic5}`,
        id: 5
    },
    {
        src: `${pic6}`,
        id: 6
    },
    {
        src: `${pic7}`,
        id: 7
    },
    {
        src: `${pic8}`,
        id: 8
    },
    {
        src: `${pic9}`,
        id: 9
    }
]


export default Pictures;